import { DocumentsInlineViewerContextProvider } from '@framework/common-web/ui/documents/DocumentsInlineViewerContext.tsx';
import { DocumentsInlineViewerDrawer } from '@framework/common-web/ui/documents/DocumentsInlineViewerDrawer.tsx';
import { useMemo } from 'react';
import { ThemeProvider, useTheme } from 'styled-components';

/**
 * Provider locale per abilitare la visualizzazione inline dei PDF
 * esclusivamente nell'area del riepilogo esteso.
 *
 * Sovrascrive `enablePdfDrawer` nel tema solo per i componenti figli,
 * fornisce un DocumentsInlineViewerContext dedicato con il relativo Drawer,
 * senza impattare il resto dell'applicazione.
 */
export function SummaryInlineViewerProvider(props: React.PropsWithChildren) {
  const outerTheme = useTheme();

  const theme = useMemo(
    () => ({ ...outerTheme, enablePdfDrawer: true }),
    [outerTheme],
  );

  return (
    <ThemeProvider theme={theme}>
      <DocumentsInlineViewerContextProvider isEnabled>
        <DocumentsInlineViewerDrawer />
        {props.children}
      </DocumentsInlineViewerContextProvider>
    </ThemeProvider>
  );
}
